"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ScreenReaderOnly = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var ScreenReaderOnly = (0, _styled.default)('span')({
  position: 'absolute',
  width: '1px',
  clip: 'rect(0 0 0 0)',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
});
exports.ScreenReaderOnly = ScreenReaderOnly;
var _default = ScreenReaderOnly;
exports.default = _default;